







































import { Component, Prop } from 'vue-property-decorator';
import _ from 'lodash';
import { ValidationMessageCpt, SelectableInputComponent } from '.';
import { DirectiveOptions } from 'vue';

// This is to add an aria-label to the upload input, and make it readable by screen readers
const SetAriaAttributesDirective: DirectiveOptions = {
  inserted(el, binding) {
    setTimeout(() => {
      const input = el.querySelector('.el-input__inner');
      input?.setAttribute('role', 'combobox');
      input?.setAttribute('aria-required', binding.value);
    }, 100); // Ensure input is fully rendered before modifying it
  },
};

@Component({
  components: {
    ValidationMessageCpt,
  },
  directives: {
    setAriaAttributes: SetAriaAttributesDirective,
  },
})
export default class InputSelectCpt extends SelectableInputComponent {
  @Prop() onClear: () => void;
  @Prop({ default: false }) multiple: boolean;
  @Prop({ default: false }) filterable: boolean;
  @Prop({ default: false }) addAll: boolean;

  addAllItems() {
    (this.model as any)[this.prop] = _.map(this.lookups, this.lookupIdProp);
    this.$forceUpdate();
  }

  clearSelection() {
    // NOTE: If using the onClear, the same kind of deletion and force update needs
    // to be done in the parent component as well to clean up the original "model"
    delete (this.model as any)[this.prop];
    this.$forceUpdate();
    this.onClear();
  }
}
